"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue3_compat_1 = require("@/client/vue3-compat");
const CardRowData_vue_1 = require("@/client/components/card/CardRowData.vue");
exports.default = (0, vue3_compat_1.defineComponent)({
    name: 'CardRenderData',
    props: {
        renderData: {
            type: Object,
            required: true,
        },
    },
    components: {
        CardRowData: CardRowData_vue_1.default,
    },
});
